<template>
  <base-section id="core-values" space="56" class="grey lighten-4">
    <v-container>
      <v-row justify="space-between">
        <v-col cols="12" md="12">
          <!-- <base-business-info title="Core Values" text=""> </base-business-info> -->
          <base-img
            :src="require('@/assets/core-values.jpg')"
            class="mr-2"
            width="100%"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionCoreValues"
};
</script>
